package dev.jfronny.zerointerest.db

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import dev.jfronny.zerointerest.`data`.TrustState
import kotlin.Int
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.reflect.KClass

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class SummaryTrustDao_Impl(
  __db: RoomDatabase,
) : SummaryTrustDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfSummaryTrustEntity: EntityInsertAdapter<SummaryTrustEntity>

  private val __zeroInterestTypeConverters: ZeroInterestTypeConverters =
      ZeroInterestTypeConverters()
  init {
    this.__db = __db
    this.__insertAdapterOfSummaryTrustEntity = object : EntityInsertAdapter<SummaryTrustEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `SummaryTrustEntity` (`roomId`,`eventId`,`state`) VALUES (?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: SummaryTrustEntity) {
        statement.bindText(1, entity.roomId)
        statement.bindText(2, entity.eventId)
        val _tmp: String = __zeroInterestTypeConverters.fromTrustState(entity.state)
        statement.bindText(3, _tmp)
      }
    }
  }

  public override suspend fun insert(entity: SummaryTrustEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfSummaryTrustEntity.insert(_connection, entity)
  }

  public override suspend fun getTrustState(roomId: String, eventId: String): TrustState? {
    val _sql: String = "SELECT state FROM SummaryTrustEntity WHERE roomId = ? AND eventId = ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        _argIndex = 2
        _stmt.bindText(_argIndex, eventId)
        val _result: TrustState?
        if (_stmt.step()) {
          val _tmp: String?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getText(0)
          }
          if (_tmp == null) {
            _result = null
          } else {
            _result = __zeroInterestTypeConverters.toTrustState(_tmp)
          }
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun clear(roomId: String) {
    val _sql: String = "DELETE FROM SummaryTrustEntity WHERE roomId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
